var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "19A52FBE-B99D-4902-956B-9068AC6A6292-6815-0000203375D64B7C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.95199981,7.99999974 L0.639999984,2.68799992 C0.383999993,2.43199993 0.128000001,1.91999994 0.128000001,1.53599995 C0.128000001,0.76799998 0.76799998,0.128000001 1.53599995,0.128000001 C1.91999994,0.128000001 2.30399993,0.383999993 2.68799992,0.639999984 L7.99999974,5.95199981 L13.3119996,0.639999984 C13.5679996,0.383999993 13.9519995,0.128000001 14.4639995,0.128000001 C15.2319995,0.128000001 15.8719995,0.76799998 15.8719995,1.53599995 C15.8719995,1.91999994 15.6159995,2.30399993 15.3599995,2.55999992 L9.98399968,7.93599974 L15.4879995,13.4399996 C15.7439995,13.6959996 15.8719995,14.0799995 15.8719995,14.4639995 C15.8719995,15.2319995 15.2319995,15.8719995 14.4639995,15.8719995 C14.0799995,15.8719995 13.6959996,15.7439995 13.4399996,15.4879995 L7.93599974,9.98399968 L2.55999992,15.3599995 C2.30399993,15.7439995 1.91999994,15.8719995 1.53599995,15.8719995 C0.76799998,15.8719995 0.128000001,15.2319995 0.128000001,14.4639995 C0.128000001,14.0799995 0.255999997,13.6959996 0.511999988,13.4399996 L5.95199981,7.99999974 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visuals",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Billing---Issuer-details",
    transform: "translate(-1392.000000, -275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-cards-/-details-/-Customer-ID-thin-Copy",
    transform: "translate(0.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-ID-card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1281.333333, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close",
    transform: "translate(111.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-lineart-/--functional-secondary-close"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#717272",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colors/global/Dark-grey",
    mask: "url(#mask-2)",
    fill: "#7C7E80"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.333333, -9.333333)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 34.6666679,
    height: 34.6666679
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0a5895392aead6e311053238ebaa6dfd.svg";
export { ForwardRef as ReactComponent };